import { useState } from 'react';

const UseDeactivationModals = () => {
  const [isDeactivateUserConfirmModalOpen, setDeactivateUserConfirmModalOpen] = useState(false);
  const [isDeactivateUserSuccessModalOpen, setDeactivateUserSuccessModalOpen] = useState(false);
  const [isReactivateUserConfirmModalOpen, setReactivateUserConfirmModalOpen] = useState(false);
  const [isReactivateUserSuccessModalOpen, setReactivateUserSuccessModalOpen] = useState(false);

  const setDeactivateUserConfirmModal = (value: boolean) => {
    setDeactivateUserConfirmModalOpen(value);
  };

  const setDeactivateUserSuccessModal = (value: boolean) => {
    setDeactivateUserSuccessModalOpen(value);
  };

  const setReactivateUserConfirmModal = (value: boolean) => {
    setReactivateUserConfirmModalOpen(value);
  };

  const setReactivateUserSuccessModal = (value: boolean) => {
    setReactivateUserSuccessModalOpen(value);
  };

  return {
    isDeactivateUserConfirmModalOpen,
    isDeactivateUserSuccessModalOpen,
    isReactivateUserConfirmModalOpen,
    isReactivateUserSuccessModalOpen,
    setDeactivateUserConfirmModal,
    setDeactivateUserSuccessModal,
    setReactivateUserConfirmModal,
    setReactivateUserSuccessModal,
  };
};

export default UseDeactivationModals;
